import { getPlantByIdOptions } from "@sunner-cloud/api-client";
import { useQuery } from "@tanstack/react-query";

export const usePlantTimezoneState = (
  plantId: string,
): { timezone: string; isReady: boolean; isError: boolean } => {
  const {
    data: plant,
    isSuccess,
    isError,
  } = useQuery({
    ...getPlantByIdOptions({ path: { plant_id: plantId } }),
    enabled: !!plantId,
  });

  return {
    // `||` y no `??`: una timezone vacía ("") también debe caer al fallback,
    // evitando que `toLocaleDateString` lance RangeError en los consumidores.
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    timezone: plant?.timezone || "UTC",
    // Listo cuando la query se resuelve, sea éxito o error: ante fallo o
    // timezone nula caemos al fallback "UTC" en vez de bloquear para siempre a
    // los consumidores con `enabled: ... && isReady`.
    isReady: isSuccess || isError,
    // El fallback "UTC" pintaría horas equivocadas como si fueran las de la
    // planta; se expone el error para que el consumidor lo muestre en su lugar.
    isError,
  };
};

export const usePlantTimezone = (plantId: string): string =>
  usePlantTimezoneState(plantId).timezone;
